import useOperationalAccess from "./hooks/useOperationalAccess";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { KitchenDisplay } from "./pages/kitchenDisplay";
import { Settings } from "./pages/settings";
import { ListDisplay } from "./pages/listDisplay";
import { Menu } from "./pages/menu";
import { UserSelect } from "./pages/userSelect";
import { Alert } from "./components/alert";
import { LoaderComponent } from "./components/loaderComponent";
import packageJson from "../package.json";
import Initializer from "./hooks/initializer";
import { ReadyOrders } from "./pages/readyOrders";

function App() {
  useOperationalAccess();
  const [ready, setReady] = useState(false);
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);

  const Component = () => {
    if (logged) {
      switch (componentActive) {
        case "userSelect":
          return (
            <>
              <UserSelect />
              <Alert />
            </>
          );
        case "kd":
          return (
            <>
              <Menu />
              <KitchenDisplay />
            </>
          );
        case "listdisplay":
          return (
            <>
              <Menu />
              <ListDisplay />
            </>
          );
        case "readyOrders":
          return (
            <>
              <Menu />
              <ReadyOrders />
            </>
          );
        case "settings":
          return (
            <>
              <Menu />
              <Settings />
              <Alert />
            </>
          );

        default:
          return (
            <>
              <UserSelect />
              <Alert />
            </>
          );
      }
    } else
      return (
        <>
          <UserSelect />
          <Alert />
        </>
      );
  };

  return (
    <>
      <Initializer onInit={() => setReady(true)} />
      <LoaderComponent />
      {ready ? <Component /> : null}
      <div className="appVersion">
        {packageJson.version + "/" + packageJson.dependencies["@delibrandev/utils"].replace("^", "")}
      </div>
    </>
  );
}

export default App;
